module.exports = __webpack_public_path__ + "static/media/press_3.9c8ad74d.jpg";